import React, { useMemo } from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import moment from 'moment';

import styles from './Date.module.scss';

// eslint-disable-next-line no-unused-vars
export const DatePicker = React.forwardRef(({ id, label, withAsterisks, value, onChange, ...props }, ref) => {
  const hasAsterisks = useMemo(() => {
    if (withAsterisks === false) { return false; }

    return withAsterisks || (
      props['data-__meta'] && props['data-__meta'].rules
            && props['data-__meta'].rules.some(item => item.required === true)
    );
    // eslint-disable-next-line
  }, [ props ]);

  return (
    <div className={ styles.inputWrapper }>
      <label
        data-testid={ `${id}-datePicker-label` }
        className={ styles.label }
      >
        {`${label}`}
        {hasAsterisks && <span className={ styles.asterisks }>{' *'}</span>}
      </label>
      <div className={ styles.inputField }>
        <AntdDatePicker
          id={ `${id}-datePicker` }
          data-testid={ `${id}-datePicker` }
          style={ styles }
          placeholder="DD-MM-YYYY"
          format="DD-MM-YYYY"
          value={ value ? moment(value, 'DD-MM-YYYY') : null }
          onChange={ (momentValue, stringValue) => {
            onChange(stringValue);
          } }
          { ...props }
        />
      </div>
    </div>
  );
});
